module.exports = __webpack_public_path__ + "static/media/5.3ede4baf.jpg";